import React from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import LucaFanitinCooking from "../../../assets/Luca_Fatin_cooking.jpg"
import dishImage from '../../../assets/top_view_round_ingredient.png';
import { getArray } from '../../../utils/helpers';

const SpecialtiesSection = ({t}) => {
    const [ref, inView] = useIntersectionObserver();

    return (
        <section className="container mx-auto px-4 py-16" ref={ref}>
            <div className="flex flex-col md:flex-row gap-8">
                {/* Left Column */}
                <div className="md:w-1/2 flex flex-col justify-center">
                    <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{t?.title}</h5>
                    <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{t?.subTitle}</h2>
                    
                    <ul className="space-y-4 mb-8">
                        {getArray(t?.lists).map((item, index) => (
                            <li key={index} className="flex items-start">
                                <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Right Column */}
                <div className="md:w-1/2 relative">
                    <img
                        src={LucaFanitinCooking}
                        alt="Chef decorating carrots"
                        width={1333}
                        height={2000}
                        className="w-full h-auto rounded-lg"
                    />
                    <div className="absolute top-[40%]">
                        <div style={{transform: 'translateX(-82%) translateY(-27%) rotate(-140deg)'}}>
                            <img 
                                src={dishImage}
                                alt="Appetizing bruschetta"
                                width={1000}
                                height={1000}
                                className={`w-1/2 h-auto transition-opacity duration-1000 ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SpecialtiesSection;
